import { useState, useEffect, useRef } from "react";
import axios from "axios";

function ManagerSelector({ onSelect }) {

const [managers,setManagers]=useState([]);
const [search,setSearch]=useState("");

const [selectedIndex,
setSelectedIndex]=useState(-1);

const searchInputRef=useRef(null);

const loadManagers=async()=>{

try{

const token=
localStorage.getItem("token");

const response=
await axios.get(

"https://saleupcall.com/api/Manager/get-managers.php",

{
headers:{
Authorization:
`Bearer ${token}`
}
}

);

if(response.data.status){

setManagers(
response.data.data || []
);

}

}
catch(error){

console.log(error);

}

};

useEffect(()=>{

loadManagers();

},[]);

useEffect(()=>{

const timer=
setTimeout(()=>{

searchInputRef.current?.focus();

},200);

return()=>clearTimeout(timer);

},[]);


// Search se matching row select

useEffect(()=>{

if(search===""){

setSelectedIndex(-1);

return;

}

const index=

managers.findIndex(

(manager)=>

(manager.username || "")
.toLowerCase()
.startsWith(
search.toLowerCase()
)

||

(manager.employee_code || "")
.toLowerCase()
.startsWith(
search.toLowerCase()
)

);

setSelectedIndex(index);

},[search,managers]);

return(

<>

<input

ref={searchInputRef}

type="text"

className="form-control mb-2"

placeholder="Search Manager"

value={search}

onChange={(e)=>
setSearch(
e.target.value
)
}

onKeyDown={(e)=>{

// Down arrow

if(e.key==="ArrowDown"){

e.preventDefault();

setSelectedIndex((prev)=>{

if(prev===-1){

return 0;

}

return Math.min(
prev+1,
managers.length-1
);

});

}


// Up arrow

if(e.key==="ArrowUp"){

e.preventDefault();

setSelectedIndex((prev)=>{

return Math.max(
prev-1,
0
);

});

}


// Enter

if(
e.key==="Enter"
&&
managers[selectedIndex]
){

e.preventDefault();

onSelect({

id:
managers[selectedIndex].id,

name:
managers[selectedIndex]
.username

});

}

}}

style={{
caretColor:"black"
}}

/>


<div
style={{
maxHeight:"400px",
overflow:"auto"
}}
>

<table
className="table table-bordered table-hover table-sm"
>

<thead
className="table-success"
>

<tr>

<th>ID</th>
<th>Employee Code</th>
<th>Username</th>
<th>Mobile</th>
<th>Department</th>

</tr>

</thead>

<tbody>

{

managers.map(

(manager,index)=>(

<tr

key={manager.id}

className={
index===selectedIndex
?
"table-primary"
:
""
}

style={{
cursor:"pointer"
}}

onClick={()=>{

setSelectedIndex(index);

onSelect({

id:manager.id,

name:manager.username

});

}}

>

<td>{manager.id}</td>

<td>
{manager.employee_code}
</td>

<td>
{manager.username}
</td>

<td>
{manager.mobile}
</td>

<td>
{manager.department_name}
</td>

</tr>

)

)

}

</tbody>

</table>

</div>

</>

);

}

export default ManagerSelector;
